import { AuthData, logout, refreshLogout } from "../redux/auth";
import { store as reduxStore } from "../redux/store";
import * as Sentry from "@sentry/react";

type ErrorResponse = {
  data: any;
  errors: object[];
  code: number;
  message: string;
};
let timeout;
var debounce = function (func, delay) {
  clearTimeout(timeout);
  timeout = setTimeout(func, delay);
};
async function checkForError(response: Response) {
  if (response.status >= 400 && response.status <= 511) {
    const contentType = response.headers.get("Content-Type");

    if (response.status === 403 && process.env.NODE_ENV === "development") {
      Sentry.captureMessage("Forbidden Resource Accessed (403)", {
        level: "error",
        extra: {
          url: window.location.href,
        },
      });
    }

    if (contentType && contentType.includes("application/json")) {
      const error: ErrorResponse = await response.json();
      const isTokenTimedOut =
        error?.message?.toLowerCase().includes("tokeninvalid") ||
        error?.message?.toLowerCase().includes("tokenexpired");
      if (
        (response.status === 403 || response.status === 401) &&
        localStorage.getItem("_auth") &&
        isTokenTimedOut
      ) {
        if (response.url.includes("/auth/refresh")) {
          reduxStore.dispatch(logout());
          window.location.pathname = "/auth/login";
          return;
        }

        debounce(function () {
          reduxStore.dispatch(refreshLogout());
        }, 1000);

        return;
      }

      error.code = response.status;
      if (error.errors || error.message) {
        if (error.message) {
          if (error?.data?.swmsStep == undefined) {
            if (window["alertContainer"]) {
              window["alertContainer"].error(error.message);
            }
          }
        } else {
          window["alertContainer"].error(`${Object.values(error.errors)[0]}`);
        }
        throw error;
      }
    }
    return response;
  }
  return response;
}

type RequestMethod =
  | "get"
  | "post"
  | "put"
  | "delete"
  | "GET"
  | "POST"
  | "PUT"
  | "DELETE";

function baseUrl(url) {
  if (window.location.host == "dev.insite.work") {
    return `https://api-dev.insite.work${url}`;
  } else if (window.location.host == "staging.insite.work") {
    return `https://api-staging.insite.work${url}`;
  } else if (
    window.location.host == "insite.work" ||
    window.location.host == "www.insite.work"
  ) {
    return `https://api.insite.work${url}`;
  }

  return `https://api-dev.insite.work${url}`;
}

function getSafeToken(key: string): string | null {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
}

export function doFetch(
  url: string,
  method: RequestMethod = "get",
  data = {},
  headers = {}
) {
  const params: RequestInit = { headers };

  /*   const baseUrl =
    typeof window.KS_ENV === "undefined"
      ? window.location.origin
      : `https://api-${window.KS_ENV}.keensafety.com.au/`;
  const urlObj = new URL(url, baseUrl);
  console.log(urlObj.href, "ur;"); */
  // const rewrittenUrl = urlObj.href;
  const rewrittenUrl = `https://api-dev.insite.work${url}`;

  // if token exist, set in header.
  const auth: AuthData = JSON.parse(localStorage.getItem("_auth"));

  if (url.includes("/auth/refresh")) {
    const refreshToken = getSafeToken("_refreshToken");
    if (refreshToken) {
      params.headers["Authorization"] = `Bearer ${refreshToken}`;
    }
  } else if (auth?.token) {
    params.headers["Authorization"] = `Bearer ${auth.token}`;
  }

  // when trying to upload files.
  if (url.includes("/v3/files") && method.toUpperCase() !== "GET") {
    params.method = method;
    params.body = data as any;
  }

  if (method.toLowerCase() !== "get" && !url.includes("/v3/files")) {
    params.method = method;
    params.headers["Content-Type"] = "application/json";
    if (method.toLowerCase() !== "delete") {
      params.body = JSON.stringify(data);
    }
  }
  return (
    fetch(baseUrl(url), params)
      // .then(checkStatus)
      .then(checkForError)
      .then((response) => {
        const contentType = response.headers.get("Content-Type");
        if (contentType.includes("application/json")) {
          return response.json();
        } else {
          return response;
        }
      })
      .then((response) => {
        if (response?.message) {
          window["alertContainer"].info(response.message);
        }
        return response;
      })
  );
}

export { ErrorResponse };
